import { ca } from '@cian/analytics';

export function trackQuickLinksBlockShow() {
  ca('eventSite', {
    action: 'show',
    label: 'to_listing',
    category: 'Mortgage',
    name: 'oldevent',
  });
}

export function trackNewbuildingClick() {
  ca('eventSite', {
    action: 'click_new',
    label: 'to_listing',
    category: 'Mortgage',
    name: 'oldevent',
  });
}

export function trackOldHousesClick() {
  ca('eventSite', {
    action: 'click_old',
    label: 'to_listing',
    category: 'Mortgage',
    name: 'oldevent',
  });
}
